import { API_ROOT } from "../../supplementary_components/requests"
import {isValidState, isValidZip, phoneNumberTyping, isValidPhoneNumber, isValidEmailAddress } from "../../supplementary_components/supplementaryMethods"


export const BROKER_ADD_CONF = {
    formAccessLevel:{ key: 'BROKERS', level: 'MANAGE' },
    formTitle: "Add Broker",
    name: 'addBrokerForm',
    addLink: API_ROOT+'brokers/add',
    successMessage:'Broker was added',
    columns: [
        {
            label: "Brokerage Name",
            name: "brokerageName",
            mandatory: true,
        },
        {
            label: "MC Number",
            name: "mcNumber",
        },
        {
            label: "Address Line 1",
            name: "addressLine1",
        },
        {
            label: "Address Line 2",
            name: "addressLine2",
            autoComplete:"off"
        },
        {
            label: "City",
            name: "city",
            mandatory: true,
        },
        {
            label: "State",
            name: "state",
            mandatory: true,
            onblur:(val)=>{
                const newVal = isValidState(val);
                return newVal ? newVal : ''
            }
        },
        {
            label: "Postal Code",
            name: "postalCode",
            onblur:(val)=>{
                const newVal = isValidZip(val);
                return newVal ? newVal : '';
            }
        },
        {
            label: "Main Line",
            name: "mainNumber",
            filters:[
                phoneNumberTyping
            ],
            onblur:(val, tar)=>{
                return isValidPhoneNumber(val, tar);
            }
        },
        {
            label: "Main Email",
            name: "mainEmail",
            onblur:(val, target)=>{
                return isValidEmailAddress(val, target);
            }
        },
        {
            label: "Invoices Factored",
            name: "factorInvoices",
            type: "select",
            dataset: ["Factored", "Not Factored"],
            // valueInterpreter: (value)=>{
            //     return value ? "Available" : "Unavailable";
            // },
            processBeforeSending: val => {
                return (val === "Factored");
            },
        },
        {
            label: "Uses Vector",
            name: "usesVector",
            type: "select",
            dataset: ["No", "Yes"],
            processBeforeSending: val => {
                return val === "Yes";
            },
        }
    ]
}